import { Button, UiKitRoot } from '@cian/ui-kit';
import * as style from './styles.css';
import { clsx } from 'clsx';
import { TWithModalProps } from 'shared/common/types/components';
import { EModalSource } from 'shared/common/types/modal';
import { FC } from 'react';

type THelpYouBuyProps = TWithModalProps;

export const UTP = [
  {
    title: <span>Выбрали лучших агентов по&nbsp;своим&nbsp;критериям качества</span>,
    imageClass: 'photos',
  },
  {
    title: 'Ваш объект увидит максимум покупателей',
    imageClass: 'duck',
  },
  {
    title: <span>Без предоплат и скрытых комиссий</span>,
    imageClass: 'umbrella',
  },
];

export const HelpYouBuy: FC<THelpYouBuyProps> = ({ device, onOpenModal }) => {
  return (
    <div className={style['light-theme-wrapper']}>
      <UiKitRoot theme="light">
        <div className={clsx(style['container'], style[device])}>
          <div className={clsx(style['wrapper'], style[device])}>
            <div className={style['title-row']}>
              <div className={style['left-child']}>
                <div className={style['name']}>Сделка на Циане</div>
                <div className={style['title']}>
                  Покупка под&nbsp;контролем:
                  <br />
                  надёжный агент и&nbsp;гарантия
                  <br />
                  безопасности сделки
                </div>
                <div className={style['btn-container']}>
                  <Button
                    theme="fill_white_primary"
                    size="L"
                    onClick={() => onOpenModal(EModalSource.Consultation)}
                    fullWidth
                  >
                    Получить консультацию
                  </Button>
                </div>
              </div>
              <div className={style['cover-image']} />
            </div>

            <div className={style['bottom']}>
              <div className={style['btn-container-bottom']}>
                <Button
                  theme="fill_white_primary"
                  size="L"
                  onClick={() => onOpenModal(EModalSource.Consultation)}
                  fullWidth
                >
                  Получить консультацию
                </Button>
              </div>
            </div>
          </div>
        </div>
      </UiKitRoot>
    </div>
  );
};
